import Product from "./Product";

export default function Opco({ product }){

    return product &&

        <Product product={product}>

            <div className="apply-option-title">
                <span>OPCO</span>
            </div>

            <div className="apply-option-row">
                <span>Financement intégral possible</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Aucune avance de frais (sous conditions)</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Plan de formation personnalisé</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Dossier de prise en charge à déposer</span>
            </div>

            <div className="apply-option-divider"></div>

            <div className="apply-option-row">
                <span>Délai de suivi de formation au choix</span>
            </div>

        </Product>
}